import { customerSelectorToolbarStyles } from "@insite/content-library/Components/CustomerSelectorToolbar";
import { css } from "styled-components";

Object.assign(customerSelectorToolbarStyles, {
    ...customerSelectorToolbarStyles,
    searchButton: {
        variant: "primary",
        css: css`
            margin-left: auto;
            :hover {
                background-color: #ab161a;
                border-color: #ab161a;
            }
        `,
    },
    wideCreateNewAddressButton: {
        variant: "primary",
        css: css`
            margin-left: 10px;
            :hover {
                background-color: #ab161a;
                border-color: #ab161a;
            }
        `,
    },
});
